import { Track } from "./Track.types";

export const generateEmptyTrack = (override?: Partial<Track>): Track => ({
  averageTime: 0,
  id: undefined!,
  lapRecord: 0,
  location: "",
  name: "",
  turns: 0,
  userId: "",
  ...override,
});
